import { Mutations, Actions, Module } from 'vuex-smart-module'

import type { ClaimFormSerialize } from '@/models'

import { loading as loadingModule, LoadingGetters } from '@/store/modules/loading'
import { ClaimForm } from '@/models'
import { CaptchaCheck, ClaimsService, SelectItem } from '@/api'

const loading = loadingModule.clone()

class ClaimState {
  form: ClaimFormSerialize = null
  docsType: Array<SelectItem> = []
}

class ClaimGetters extends LoadingGetters<ClaimActions, ClaimState> {
  get isSendForm() {
    return this.state.loading.loaders.sendForm
  }
}

class ClaimMutations extends Mutations<ClaimState> {
  setForm(form?: ClaimForm) {
    this.state.form = form
  }

  setDocsType(docs: Array<SelectItem>) {
    this.state.docsType = docs
  }
}

class ClaimActions extends Actions<ClaimState, ClaimGetters, ClaimMutations, ClaimActions> {
  async sendForm({ form, captcha }: { form: ClaimFormSerialize; captcha: CaptchaCheck }): Promise<void> {
    await ClaimsService.create({ claim: form, captcha })
  }

  async getDocsType() {
    const docs = await ClaimsService.getVisibleDocsType()
    this.mutations.setDocsType(docs.list)
  }
}

export type ClaimModules = {
  loading: typeof loading
}

export const claim = new Module<ClaimState, ClaimGetters, ClaimMutations, ClaimActions, ClaimModules>({
  modules: { loading },
  state: ClaimState,
  getters: ClaimGetters,
  mutations: ClaimMutations,
  actions: ClaimActions,
})
